import { ColorScheme } from '@/types'
import { Tag, type TagProps } from '@chakra-ui/react'
import React from 'react'


interface Props extends TagProps {
  colorScheme?: ColorScheme,
}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {

  return (
    <Tag ref={ref} { ...props } />
  )
})

export {
  Component as Tag,
  type Props as TagProps,
}
